import React, { useReducer } from 'react';
import { reducer } from './reducer';
import { initialDTCState } from './state';

export const BuildPlanContext = React.createContext(null);

export const BuildPlanContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialDTCState);

    return <BuildPlanContext.Provider value={{ state, dispatch }}>{children}</BuildPlanContext.Provider>;
};
